import React from 'react';
import { raiseToast } from '@fiverr-private/toast';
import { Stack } from '@fiverr-private/layout_components';
import { translate } from '@fiverr-private/i18n-react';
import { ListLink } from '../ListLink/ListLink';

import { ErrorKey, isErrorKey } from '../../utils/isCollectionKimeraError';
import { linkToastWrapperClass } from './toasts.ve.css';

const LOCATION = 'top';

const TOAST_SOURCE = 'list_updated_toast';

export const raiseListCreated = () => {
    raiseToast({
        type: 'success',
        location: LOCATION,
        message: translate('collect_actions.toasts.list_created'),
    });
};

export const raiseCreateListError = (errorKey?: ErrorKey | string) => {
    const suffix = isErrorKey(errorKey) ? errorKey : 'list_create_failed';
    raiseToast({
        type: 'error',
        location: LOCATION,
        message: translate(`collect_actions.toasts.${suffix}`),
    });
};

export const raiseListSaved = () => {
    raiseToast({
        type: 'success',
        location: LOCATION,
        message: translate('collect_actions.toasts.list_saved'),
    });
};

export const raiseSaveListError = (errorKey?: ErrorKey | string) => {
    const suffix = isErrorKey(errorKey) ? errorKey : 'save_failed';
    raiseToast({
        type: 'error',
        location: LOCATION,
        message: translate(`collect_actions.toasts.${suffix}`),
    });
};

export const raiseListDeleted = () => {
    raiseToast({
        type: 'success',
        location: LOCATION,
        message: translate('collect_actions.toasts.list_deleted'),
    });
};

export const raiseDeleteListError = () => {
    raiseToast({
        type: 'error',
        location: LOCATION,
        message: translate('collect_actions.toasts.list_delete_failed'),
    });
};

export const raiseSavedToList = (collectionSlug: string, collectionName: string) => {
    raiseToast({
        type: 'success',
        location: LOCATION,
        message: (
            <Stack gap="0" wrap="wrap" justifyContent="flexStart" className={linkToastWrapperClass}>
                {translate('collect_actions.toasts.saved_to_list', {
                    templates: {
                        list_link: (text) => (
                            <ListLink collectionSlug={collectionSlug} source={TOAST_SOURCE}>
                                {text}
                            </ListLink>
                        ),
                    },
                    params: { list_name: collectionName },
                })}
            </Stack>
        ),
    });
};

export const raiseRemovedFromList = (collectionName: string) => {
    raiseToast({
        type: 'success',
        location: LOCATION,
        message: translate('collect_actions.toasts.removed_from_list', {
            params: { list_name: collectionName },
        }),
    });
};

export const raiseRemoveFromListError = () => {
    raiseToast({
        type: 'error',
        location: LOCATION,
        message: translate('collect_actions.toasts.unsave_failed'),
    });
};
